<template>
  <modal
    class="editCreditLimit"
    name="updateMaint"
    transition="pop-out"
    :width="modalWidth"
    :height="400"
  >
    <div class="text-center py-4">
      <h4>{{ $t("text.iMarkMaintenance.updateComment") }}</h4>
    </div>
    <div class="sign_up_form_section">
      <form>
        <div class="row justify-content-center">
          <div class="col-md-7">
            <div class="mt-3">
              <label>{{ $t("text.iMarkMaintenance.comment") }}</label>
              <div class="price_change_input_wrapper" ref="e_div">
                <textarea
                  type="text"
                  v-model="comment"
                  :placeholder="$t('text.iMarkMaintenance.comment')"
                  rows="3"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center mt-3">
          <div class="col-md-7">
            <div ref="re"></div>
          </div>
        </div>
        <div class="text-center mt-3">
          <button
            class="show_more_button remove_text_decoration"
            @click="updateMaintenance($event)"
            :style="[
              isButtonDisabled
                ? { cursor: 'not-allowed' }
                : { cursor: 'pointer' },
            ]"
          >
            {{ $t("text.actionButtons.update") }}
            <span></span>
          </button>
          <img
            src="@/assets/img/git_loader.gif"
            style="display: none"
            width="35px"
            class="ml-3 loader"
          />
        </div>
      </form>
    </div>
  </modal>
</template>
<script>
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

const MODAL_WIDTH = 656;

export default {
  name: "updateMaint",
  props: ["mtSchedule"],
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      amount: null,
      comment: null,
      company: localStorage.getItem("companyDetails")
        ? JSON.parse(localStorage.getItem("companyDetails"))
        : null,
      isButtonDisabled: false,
    };
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;

    //   this.updateMaintenance()
  },

  mounted() {},
  methods: {
    updateMaintenance($event) {
      $event.preventDefault();
      if (!this.comment) {
        this.$toast.open({
          message: this.$t("text.iMarkMaintenance.commentMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      $(".loader").show();

      const data = {
        comment: this.comment,
      };
      this.axios
        .put(
          `${configObject.apiBaseUrl}/Branch/UpdateMaintenance/${this.mtSchedule.id}`,
          data,
          configObject.authConfig()
        )
        .then((res) => {
          this.comment = null;
          this.$toast.open({
            message: this.$t("text.iMarkMaintenance.successfullyyUpdatedTrack"),
            type: "success",
            duration: 5000,
          });

          this.$modal.hide("updateMaint");
        })
        .catch((error) => {});
    },
  },
};
</script>
